/**
 * Utility function to conditionally join class names.
 *
 * @param {Array<string>} classNames - An array of class names.
 * @returns {string} - A string of class names joined by a space.
 */
export const classNames = (classNames) =>
  Array.isArray(classNames) ? classNames.filter(Boolean).join(' ').trim() : classNames;
